export default __webpack_public_path__ + "static/media/hero-image.fc11e416.png";